import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Magic from './magic-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Magic {...validProps} />;
}
SvgComponent.iconName = 'magic';

/**
 * @deprecated This is a legacy icon
 */
export const MagicIcon = svgIconWrapper(SvgComponent);
